import * as React from 'react';

import { CardController } from 'src/app/shared/card.controller';
import { AgentListController } from 'src/app/bookings/agents/list/agent-list.controller';

interface Props extends ComponentViewProps<AgentItem> {
	match: any;
	location: any;
	history: any;
}

export const ChildrenAgents = (props: Props) => {
	const {
		model, setBusy,
		match, location, history
	} = props;
	const responsibleAgentId = model.id > 0 ? model.id : -1;

	return (
		<CardController
			title="Children Agents"
			icon="user"
			className="card-borderless no-padding-inside"
			mode="display">
			<AgentListController
				responsibleAgentId={responsibleAgentId}
				match={match}
				location={location}
				history={history}
				setBusy={setBusy}
			/>
		</CardController>
	);
};



// WEBPACK FOOTER //
// ./src/app/bookings/agents/form/parts/children-agents.tsx